import {defineComponent} from 'vue';
import {goBack} from "@/config/link";
import {PayRecordSearchVO} from "@/declares/vo/payCenter/PayRecordSearchVO";
import PayTypeIcon from "@/support/components/common/PayTypeIcon";
import moment from 'moment';
import {payRecordStatusEnum} from "@/declares/options/payCenter/payRecordStatusOptions";
import {msgOnErr} from "@/support/util/catchMsg";
import {payRecordApi} from "@/apis/payCenter/payRecordApi";
import {message} from "@/support/util/message";


export class PayRecordInfoCardProps {
  model: PayRecordSearchVO = new PayRecordSearchVO();
}


function PayRecordDetailInfoCard(_props: any, ctx: any) {
  const props = _props as PayRecordInfoCardProps;


  return () => <div class="record-detail-info">
    <div class="form-title">支付详情</div>
    <el-form size="mini" label-suffix=":" label-width="90px" label-position="left">
      <el-form-item label="流水号">{props.model.flowNo}</el-form-item>
      <el-form-item label="业务编号">{props.model.bizNo}</el-form-item>
      <el-form-item label="支付应用">
        <el-button type="text">
          {props.model.appName}
        </el-button>
      </el-form-item>
      <el-form-item label="商户号">
        <el-button type="text">
          {props.model.merchantName}
        </el-button>
      </el-form-item>
      <el-form-item label="支付类型">
        <pay-type-icon payType={props.model.payType}/>
      </el-form-item>
      <el-form-item label="支付金额">
        {props.model.money}
      </el-form-item>
      <el-form-item label="创建时间">
        {moment(props.model.gmtCreate).format('YYYY-MM-DD HH:mm:ss')}
      </el-form-item>
      <el-form-item label="发起用户">
        {props.model.userNickName}
      </el-form-item>
      <el-form-item label="备注">
        {props.model.remark}
      </el-form-item>
      <el-form-item label="支付状态">
        {
          ((row) => {
            const {status, gmtNotify, gmtExpire} = row;
            switch (status) {
              case payRecordStatusEnum.notPay:
                return <el-tag type="info" size="mini">未支付</el-tag>
              case payRecordStatusEnum.success:
                return <div>
                  <el-tag type="success" size="mini">已支付</el-tag>
                  {gmtNotify ? moment(gmtNotify).format('YYYY-MM-DD HH:mm:ss') : null}
                </div>;
              case payRecordStatusEnum.timeout:
                return <div>
                  <el-tag type="warning" size="mini">支付超时</el-tag>
                  {gmtExpire ? moment(gmtExpire).format('YYYY-MM-DD HH:mm:ss') : null}
                </div>
              case payRecordStatusEnum.startPayFail:
                return <el-tag type="danger" size="mini">发起支付失败</el-tag>
            }
          })(props.model)
        }
      </el-form-item>
    </el-form>
  </div>
}


export default defineComponent({
  props: {
    model: {type: Object, required: true},
    loading: {type: Boolean, required: true}
  },
  components: {PayTypeIcon},
  setup: PayRecordDetailInfoCard
});
